import React from 'react';
import { Button } from './ui/button';
import { Phone, ArrowRight, ShoppingCart, Calendar } from 'lucide-react';
import { heroData } from '../data/mock';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();
  
  const handleOrderClick = () => {
    window.location.href = `tel:${heroData.ctaPhone}`;
  };

  const handleMenuClick = () => {
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  };
  
  const handleOrderCupcakesClick = () => {
    navigate('/order');
  };

  const handleSchedulesClick = () => {
    navigate('/schedules');
  };

  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated background */}
      <div className="hero-bg absolute inset-0 z-0"></div>
      
      {/* Floating robot decorations */}
      <div className="robot-float robot-float-1 absolute z-10"></div>
      <div className="robot-float robot-float-2 absolute z-10"></div>
      <div className="robot-float robot-float-3 absolute z-10"></div>
      
      {/* Content */}
      <div className="hero-content relative z-20 container mx-auto px-6 text-center">
        {/* Friendly Robot Figure */}
        <div className="robot-mascot mx-auto mb-8">
          <div className="robot-figure">
            {/* Robot Head */}
            <div className="robot-head relative">
              <div className="robot-antenna"></div>
              <div className="robot-face">
                <div className="robot-eyes">
                  <div className="robot-eye"></div>
                  <div className="robot-eye"></div>
                </div>
                <div className="robot-mouth"></div>
              </div>
            </div>
            {/* Robot Body */}
            <div className="robot-body">
              <div className="robot-chest">
                <div className="robot-heart"></div>
              </div>
            </div>
            {/* Robot Arms */}
            <div className="robot-arms">
              <div className="robot-arm robot-arm-left"></div>
              <div className="robot-arm robot-arm-right"></div>
            </div>
            {/* Robot Legs */}
            <div className="robot-legs">
              <div className="robot-leg"></div>
              <div className="robot-leg"></div>
            </div>
          </div>
        </div>

        {/* Farmers Market Schedules Button */}
        <div className="mb-6 animate-fade-in">
          <Button 
            onClick={handleSchedulesClick}
            className="schedules-hero-btn"
            variant="outline"
          >
            <Calendar className="h-4 w-4 mr-2" />
            Farmers Market Schedules
          </Button>
        </div>

        <div className="tagline text-lg md:text-xl font-medium mb-4 animate-fade-in">
          {heroData.tagline}
        </div>
        
        <h1 className="hero-title text-5xl md:text-7xl lg:text-8xl font-bold mb-6 animate-slide-up">
          {heroData.headline}
        </h1>
        
        <p className="hero-subtitle text-xl md:text-2xl mb-10 max-w-3xl mx-auto animate-fade-in-delayed">
          {heroData.subheadline}
        </p>

        <div className="hero-cta-group flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-more-delayed">
          <Button 
            size="lg" 
            className="cta-primary group text-lg px-8 py-6"
            onClick={handleOrderCupcakesClick}
          >
            <ShoppingCart className="mr-2 h-5 w-5" />
            Order Cupcakes
          </Button>
          <Button 
            size="lg" 
            className="cta-primary group text-lg px-8 py-6"
            onClick={handleOrderClick}
          >
            <Phone className="mr-2 h-5 w-5 group-hover:rotate-12 transition-transform" />
            {heroData.ctaText}
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="cta-secondary text-lg px-8 py-6"
            onClick={handleMenuClick}
          >
            {heroData.secondaryCta}
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        <div className="phone-highlight mt-8 text-lg font-semibold animate-pulse-soft">
          📞 {heroData.ctaPhone}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="scroll-indicator absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default HeroSection;
